/**
 * returns the size of the file with nearest possible format
 * @param {number} bytes
 * @param {number} decimals
 */
export const formatBytes = (bytes, decimals = 1) => {
  if (!bytes) return '0 Bytes';

  const unit = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];

  const size = Math.floor(Math.log(bytes) / Math.log(unit));

  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(unit, size)).toFixed(dm))} ${sizes[size]}`;
};

/**
 * Gets the extension of a filename. Example: 'CoolApp.apk' -> '.apk'
 * @param {string} fileName
 * @returns {string|undefined} undefined when the string lacks a file extension
 */
export const getExtensionFromFileName = (fileName) => (
  fileName?.match(/\.[a-z0-9]+$/i)?.[0]
);

/**
 * Gets the rounded file size in MB
 * @param {number} fileSize in bytes
 * @returns {number|undefined} undefined when fileSize is not a number
 */
export const getRoundedFileSizeInMB = (sizeInBytes) => {
  if (Number.isFinite(sizeInBytes)) {
    return Math.round(Math.abs(sizeInBytes) / 1000 ** 2);
  }
  return undefined;
};
